let selectBox = document.querySelector('.tg-select-box');
let selectOpt = document.querySelector('.tg-select-option');
let cityName = document.querySelector('#tg-city-name')
let optSearch = document.querySelector('#Optionsearch')
let opt = document.querySelector('.tg-options')
let optList = document.querySelectorAll('.tg-options li')
let cityListContent = document.querySelector('.tg-content');
selectOpt.addEventListener('click', () => {
  selectBox.classList.toggle('active');
  cityListContent.classList.toggle('active');
});
optList.forEach( item => {
  item.addEventListener('click', (evt) => {
    cityName.value = evt.target.innerText;
    selectBox.classList.remove('active');
    document.querySelectorAll('[name="checkout"]').forEach( btn => {
      btn.removeAttribute('disabled');
    });
    document.querySelector('.tg-city-list-error').style.display = 'none';
    cityListContent.classList.remove('active');
  });
});
optSearch.addEventListener('keyup', evt => {
  let filter,textValue,optList;
  filter = evt.target.value.toUpperCase();
  optList = opt.querySelectorAll('li');
  optList.forEach( opt => {
    textValue = opt.textContent || opt.innerText;
    if (textValue.toUpperCase().indexOf(filter) > -1) {
      opt.style.display = '';
    } else {
      opt.style.display = 'none';
    }
  });
});
